import { getUrl, Request } from '../../request';

export const postOrderSummary = (use_credit, city_id, discount_code, cart_items, address_id) =>
  Request.post(getUrl('/api/v1/orders/order-summary/'), {
    use_credit,
    city_id,
    discount_code,
    cart_items,
    address_id
  });

export const postRequiredFields = (cart_items) =>
  Request.post(getUrl('/api/v1/orders/required-fields/'), {
    cart_items
  });

export const postChargeWallet = (city_id, amount) =>
  Request.post(getUrl('/api/v1/orders/charge-wallet/'), {
    city_id,
    amount
  });

export const payment = (city_id, use_credit, discount_code, cart_items, user_data, address_id) =>
  Request.post(getUrl('/api/v1/orders/order/'), {
    city_id,
    use_credit,
    discount_code,
    cart_items,
    user_data,
    address_id
  });

export const getUserOrders = (id = null) =>
  Request.get(getUrl('/api/v1/orders/user-orders/'), { id });
